import { Dispatch } from "redux"

export const API_MAPPING = "API_MAPPING"
export const API_MAPPING_SUCCESS = `${API_MAPPING}_SUCCESS`
export const API_MAPPING_FAILURE = `${API_MAPPING}_FAILURE`
export const API_MAPPING_CALL = `${API_MAPPING}_CALL`

export const API_MAPPING_FORM = "API_MAPPING_FORM"
export const API_MAPPING_FORM_SUCCESS = `${API_MAPPING_FORM}_SUCCESS`
export const API_MAPPING_FORM_FAILURE = `${API_MAPPING_FORM}_FAILURE`
export const API_MAPPING_FORM_CALL = `${API_MAPPING_FORM}_CALL`

export const API_MAPPING_MODAL = "API_MAPPING_MODAL"
export const API_MAPPING_MODAL_OPEN = `${API_MAPPING_MODAL}_OPEN`
export const API_MAPPING_MODAL_CLOSE = `${API_MAPPING_MODAL}_CLOSE`

export function changeModalState(isOpen: boolean, type: "delete" | "") {
  return (dispatch: Dispatch) => {
    if (isOpen) return dispatch({ type: API_MAPPING_MODAL_OPEN, payload: { type } })

    return dispatch({ type: API_MAPPING_MODAL_CLOSE })
  }
}
